import {ajaxGet, ajaxPost, ajaxPut} from "../../ajax";
export class Functions{
    constructor(){
    }

    getThumbURL(callback, error){
        ajaxGet("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/s3/thumburl",
        (data) =>{
            callback(data);
        },(err) => {
            error(err);
        },localStorage.token);
    }

    getImageURL(callback, error){
        var uuid = this.generateuuid(32);
        ajaxGet("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/s3/putUrl?key=" + uuid + ".jpeg&content=" + decodeURIComponent("image/jpeg,image/png,image/tif,video/mp4,video/x-m4v"),
            (data) => {
                callback(data);
            },
            (err) => {
                error(err);
            }, localStorage.token);
    }

    getPdfURL(callback, error){
        var uuid = this.generateuuid(32);
        ajaxGet("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/s3/putUrl?key=" + uuid + ".pdf&content=" + decodeURIComponent("application/pdf"),
            (data) => {
                callback(data);
            },
            (err) => {
                error(err);
            }, localStorage.token);
    }

    generateuuid(len){
        if(!len) len = 16;
        let dat = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdef0ghijklmnopqrstuvwxyz1234567890".split('');
        var result = [];
        for(var i = 0; i < len; i++) result.push(dat[Math.floor(Math.random() * dat.length)]);
        return result.join('');
    }

    getSignedUrl(bucket, key, contentType, operation, callback){
        ajaxPost("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/s3/getsignedurl",
        {
            key: key,
            operation: operation,
            contentType: contentType,
            bucket: bucket
        }, (data) => {
            callback(data);
        }, (err) => console.error(err), localStorage.token);
    }

    upload(url, file, callback){
         console.log("Upload method",url, file);
        // return null;
        let xhr = new XMLHttpRequest();
        xhr.open('PUT', url, false);
        xhr.setRequestHeader('Content-type', 'image/jpeg,image/png,image/tif,image/jpg');
        xhr.onload = function(){
            callback(xhr.responseText);
        }
        xhr.onerror = function(error) {
            console.log(error);
        }
        
        xhr.send(file);
    }

    uploadVideo(url, file, callback){
        // console.log(url, file);
        // return null;
        let xhr = new XMLHttpRequest();
        xhr.open('PUT', url, false);
        xhr.setRequestHeader('Content-type', 'video/mp4');
        xhr.onload = function(){
            callback(xhr.responseText);
        }
        xhr.send(file);
    }

    uploadAudio(url, file, callback){
        // console.log(url, file);
        // return null;
        let xhr = new XMLHttpRequest();
        xhr.open('PUT', url, false);
        xhr.setRequestHeader('Content-type', 'audio/mpeg');
        xhr.onload = function(){
            callback(xhr.responseText);
        }
        xhr.send(file);
    }

    uploadPDF(url, file, callback){
        // console.log(url, file);
        // return null;
        let xhr = new XMLHttpRequest();
        xhr.open('PUT', url, false);
        xhr.setRequestHeader('Content-type', 'application/pdf');
        xhr.onload = function(){
            callback(xhr.responseText);
        }
        xhr.send(file);
    }

    addComponent(data, callback){
        ajaxPost("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/", data,
        (data) => {
            callback(data);
        },
        (err) => {
            console.log("ERR:", err);
        }, localStorage.token);
    }

    addBook(data, callback){
        ajaxPost("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/book", data,
        (data) => {
            callback(data);
        },
        (err) => {
            console.log("ERR:", err);
        }, localStorage.token);
    }

    updateBook(ID, data, callback){
        data.ID = ID;
        ajaxPost("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/book", data,
        (data) => {
            callback(data);
        },
        (err) => {
            console.log("ERR:", err);
        }, localStorage.token);
    }

    updateComponent(ID, data, callback){
        data.ID = ID;
        ajaxPost("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/", data,
        (data) => {
            callback(data);
        },
        (err) => {
            console.log("ERR:", err);
        }, localStorage.token);
    }

    updateComponentAudVid(ID, data, callback){
        data.ID = ID;
        console.log("UPDATING :", data);
        ajaxPost("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/vidaudpost", data,
        (data) => {
            callback(data);
        },
        (err) => {
            console.log("ERR:", err);
        }, localStorage.token);
    }

    getComponent(id, callback){
        //Get Component Details
        ajaxGet("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/" + id,
        (data) => {
            callback(data);
        }, (err) => {
            console.error(err);
        }, localStorage.token);
    }

    getComponentVidAud(id, callback){
        //Get Component Details
        ajaxGet("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/vidaudpost/" + id,
        (data) => {
            callback(data);
        }, (err) => {
            console.error(err);
        }, localStorage.token);
    }

    getAllComponents(callback){
        //Get Component Details
        ajaxGet("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content?Component=",
        (data) => {
            callback(data);
        }, (err) => {
            console.error(err);
        }, localStorage.token);
    }
    
    getAllContent(callback){
        //Get all content
        ajaxGet("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/allcontent",
            (data) => {
            callback(data);
            },(error) => {
            console.error(error);
            },localStorage.token);
    }
    
    getFeaturedContent(callback){
        ajaxGet("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/featuredcontent",
        (data) => {
            callback(data);
        },(error) => {
            console.error(error);
        },localStorage.token);
    }
    
    updateFeaturedContent(id,callback){
        ajaxPut("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/featured/" + id,
            (data) => {
                callback(data);
            },(error) => {
                console.error(error);
            },localStorage.token);
    }
    
    
}